import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./placepicker.scss";
import { SearchOutlined } from '@ant-design/icons';
import PlacesAutocomplete, { geocodeByAddress, getLatLng, } from 'react-places-autocomplete';
import GoogleMapReact from 'google-map-react';
// import marker from './../../assets/images/marker.png';
import { Input, Modal } from "antd";

function Placepicker(props) {
  const [query, setQuery] = useState(props.defaultAdd ? props.defaultAdd : "");
  const { t } = useTranslation();

  const [center, setCenter] = useState({ lat: parseFloat(props.defaultLocation?.lat) ?? 0, lng: parseFloat(props.defaultLocation?.lng) ?? 0 });
  const [zoom, setZoom] = useState(15);
  const [isViewMapModalOpen, setIsViewMapModalOpen] = useState(false);

  useEffect(()=>{
    setQuery(props.defaultAdd ? props.defaultAdd : "")
  },[props.defaultAdd])
  const handleSelect = address => {
    setQuery(address);
    geocodeByAddress(address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        props.onChange({
          address: address,
          lat: latLng?.lat,
          lng: latLng?.lng,
        });
        setCenter({
          lat: 0,
          lng: 0,
        })
        setTimeout(function () {
          setCenter({
            lat: latLng?.lat,
            lng: latLng?.lng,
          })
        }, 100)
      })
      .catch(error => console.error('Error', error));
  };

  const handleChangeAdd = e => {
    setQuery(e);
  }

  const openViewMapModal=()=>{
    setIsViewMapModalOpen(true);
  }

  const closeViewMapModal=()=>{
    setIsViewMapModalOpen(false)
  }


  return (
    <div className="search-location-input">
      <PlacesAutocomplete
        value={query}
        onSelect={handleSelect}
        onChange={handleChangeAdd}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div> 
            <Input suffix={<SearchOutlined style={{ color: 'var(--text-faint, rgba(0,0,0,.25))'}} />}
              {...getInputProps({
                placeholder:t("SEARCH_PLACES_GOOGLE_PH"),
                className: 'floating-input-basic',
              })}
              disabled={props.disabled}
            />
            <div className="pac-container">
              {loading && <div>Loading...</div>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = suggestion.active
                  ? { backgroundColor: 'var(--surface-2, #fafafa)', cursor: 'pointer' }
                  : { backgroundColor: 'var(--surface, #ffffff)', cursor: 'pointer' };
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
      {center.lat > 0 && query ?
      // <>
      //    <div style={{ height: '50vh', width: '100%' }}>
      //     <label title="Directions">{t("DIRECTIONS_TITLE")}</label>
      //     <GoogleMapReact
      //       bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
      //       defaultCenter={center}
      //       defaultZoom={zoom}
      //       options={{
      //         disableDefaultUI: false,
      //         mapTypeControl: false,
      //         streetViewControl: false,
      //         draggable: false
      //       }}
      //     >
      //       <div style={{ marginLeft: "-36px", marginTop: "-70px" }}><img src={marker} /></div>
      //     </GoogleMapReact>
      //    </div>
      //   </>
      <div style={{float: 'right',marginTop:'0.5rem'}}>
        {/* <span
        style={{
          color: "var(--brand-primary-strong, #ff5d00)",
          textDecoration: "underline",
          fontSize: "12px",
          fontWeight: "600",
          cursor:"pointer"
        }} onClick={openViewMapModal} >{t("PICKER_VIEW_IN_MAP_TITLE")}</span> */}
       </div>: null}
        {isViewMapModalOpen && <Modal
         title=""
         open={isViewMapModalOpen}
         onCancel={closeViewMapModal}
         width={1000}
         footer={[]}>
          <div style={{ height: '60vh', width: '100%' }}>
          <label title="Directions">{t("DIRECTIONS_TITLE")}</label>
          <GoogleMapReact
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_API_KEY }}
            defaultCenter={center}
            defaultZoom={zoom}
            options={{
              disableDefaultUI: false,
              mapTypeControl: false,
              streetViewControl: false,
              draggable: false
            }}
          >
            <div style={{ marginLeft: "-36px", marginTop: "-70px" }}>
              {/* <img src={marker} /> */}
            </div>
          </GoogleMapReact>
          </div>
        </Modal> }


    </div>
  );
}

export default Placepicker;
